module.exports = __webpack_public_path__ + "static/media/opakowania_5_C.89175948.png";